import { useSelector, useDispatch } from 'react-redux';
import useLocalStore from '../../../hooks/useLocalStore';
import FJImageEnhancerCreations from './FJImageEnhancerCreations';
import PropTypes from 'prop-types';
import { setSliceSelectCreationIdAction } from '../../../redux/slices/FJSliceImageEnhancer';
import FJUtil from '../../../util/FJUtil';
const FJImageEnhancerCreationsContainer = props => {
    const { active } = props;
    useLocalStore();
    const dispatch = useDispatch();

    const imageEnhancerCreationList = useSelector(state => state.imageEnhancer.imageEnhancerCreationList);
    const selectCreationId = useSelector(state => state.imageEnhancer.selectCreationId);
    const onSelectCreation = id => {
        dispatch(setSliceSelectCreationIdAction(id));
    };
    const onDownload = (url, callback) => {
        const tool = FJUtil.getToolName();
        FJUtil.eaLog('ai tool download click', { source: 'creation', tool });
        FJUtil.multiDownloadByUrls([url], callback);
    };
    return (
        <FJImageEnhancerCreations
            active={active}
            imageEnhancerCreationList={imageEnhancerCreationList}
            selectCreationId={selectCreationId}
            onSelectCreation={onSelectCreation}
            onDownload={onDownload}
        />
    );
};

FJImageEnhancerCreationsContainer.propTypes = {
    active: PropTypes.bool,
};
export default FJImageEnhancerCreationsContainer;
